export default __webpack_public_path__ + "resources/icons/d200-d5c5.png";